import { render } from "./AlertRanges.vue?vue&type=template&id=7f413a36&scoped=true"
import script from "./AlertRanges.vue?vue&type=script&lang=js"
export * from "./AlertRanges.vue?vue&type=script&lang=js"

import "./AlertRanges.vue?vue&type=style&index=0&id=7f413a36&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7f413a36"

export default script